// The Books Link by file (V-13): the Application API's routes for where the books are kept and the files of Tally
// vouchers not yet sent (ADR-0035).
import { call, type Fetch } from "../http.js";

export interface BooksFile {
  readonly id: string;
  readonly number: number;
  readonly name: string;
  readonly vouchers: number;
  readonly made_at: string;
  /** The file whose postings it carries again. */
  readonly again?: string;
  readonly href: string;
}

export interface BooksLinkView {
  readonly books: "lamp" | "tally";
  /** The day the link was switched on. */
  readonly since?: string;
  readonly may: { readonly keep: boolean; readonly make: boolean };
  readonly unsent: number;
  readonly files: readonly BooksFile[];
}

export interface BooksFileMade {
  /** The last file made. */
  readonly file?: BooksFile;
  /** Every file made, in order: more than one when the vouchers are more than a file takes. */
  readonly files: readonly BooksFile[];
  readonly written: number;
  readonly held: readonly {
    readonly posting: string;
    readonly document: string;
    readonly problems: readonly string[];
  }[];
}

export interface BooksLinkApi {
  shown(): Promise<BooksLinkView>;
  keepBooksIn(books: "lamp" | "tally"): Promise<BooksLinkView>;
  make(again?: string): Promise<BooksFileMade>;
}

export function createBooksLinkApi(fetcher: Fetch): BooksLinkApi {
  return {
    shown: () => call<BooksLinkView>(fetcher, "/api/books-link"),
    keepBooksIn: (books) => call<BooksLinkView>(fetcher, "/api/books-link/books", { method: "PUT", json: { books } }),
    make: (again) =>
      call<BooksFileMade>(fetcher, "/api/books-link/files", { json: again === undefined ? {} : { again } }),
  };
}
